import { Box, Flex, IconButton, List, ListItem } from "@chakra-ui/react";
import { FormDatepicker, FormInput, FormSelect } from "../../../../../components/Forms";
import { Controller } from "react-hook-form";
import { MdClose } from "react-icons/md";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { AppendToListButton } from "./index";

function NaturalDisastersFieldArray({ fields, register, errors, control, formKey, appendItem, removeItem }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "supplierPhysicalRiskQuestionnaire"
  });

  return <>
    {fields && fields.length > 0 &&
      <List>
        {fields.map((item, index) => {
          return (
            <ListItem key={item.id} marginBlockEnd="2">
              <Flex alignItems="flex-start" gap="2">
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  flexShrink="0"
                  inlineSize="8"
                  blockSize="8"
                  borderWidth="thin"
                  borderRadius="full"
                  fontSize="sm"
                  fontWeight="semibold"
                  marginBlockStart="6"
                >
                  {index + 1}
                </Box>
                <FormSelect
                  label={t("inputs.naturalDisasters")}
                  errors={errors}
                  {...register(`${formKey}.${index}.type`)}
                  defaultValue=""
                >
                  <option value="" disabled>{t("inputs.naturalDisastersPlaceholder")}</option>
                  <option value="storms">{t("naturalDisasterOptions.storms")}</option>
                  <option value="droughts">{t("naturalDisasterOptions.droughts")}</option>
                  <option value="heatwaves">{t("naturalDisasterOptions.heatwaves")}</option>
                  <option value="floods">{t("naturalDisasterOptions.floods")}</option>
                  <option value="others">{t("naturalDisasterOptions.others")}</option>
                </FormSelect>
                <Controller
                  control={control}
                  name={`${formKey}.${index}.date`}
                  render={({ field }) => {
                    const props = {};
                    if (field.value !== null && field.value !== "") {
                      props.date = field.value;
                    }
                    return <FormDatepicker
                      field={field}
                      name={`${formKey}.${index}.date`}
                      label={t("inputs.selectDate")}
                      placeholder={t("inputs.selectDate")}
                      {...props}
                    />;
                  }}
                />
                <FormInput
                  placeholder={t("inputs.eventDescriptionPlaceholder")}
                  label={t("inputs.eventDescription")}
                  errors={errors}
                  {...register(`${formKey}.${index}.description`)}
                />
                <IconButton
                  type="button"
                  icon={<MdClose size="24" />}
                  flexShrink="0"
                  variant="ghost"
                  marginBlockStart="5"
                  onClick={() => removeItem(index)}
                />
              </Flex>
            </ListItem>
          );
        })}
      </List>
    }
    <AppendToListButton
      onClick={() => {
        appendItem({
          type: "",
          date: "",
          description: ""
        });
      }}
      buttonText={t("buttons.addAnotherEvent")}
    />
  </>;
}

export default NaturalDisastersFieldArray;